module.exports = __webpack_public_path__ + "img/avion.db9bb0a2.png";